/* eslint-env browser */
/* eslint-env jquery */

require('choices.js');

window.WedFilter = {
  ajaxHandler: null,
  filterFormId: '#filter-section',
  urlSeparators: null,
  timeout: null,

  init(opts) {
    this.submitDelay = opts.submitDelay;
    this.submitType = opts.submitType || this.submitType;
    this.filterFormId = opts.filterFormId;
    this.sortOrder = null;

    this.urlSeparators = opts.urlSeparators;
    this.productListId = opts.productListId;
    const menuFilter = $('#merchant-menu-filter');
    const checkboxes = $(this.filterFormId).find('select, input').not('[name="search_text"]');
    checkboxes.change(this.currentSendMethod);

    $('#search_btn').on('click', (e) => { WedFilter.currentSendMethod(e); return false; });
    const searchInput = $('#menu-filter-search-input');
    searchInput.keypress((e) => {
      if (e.which === 13) {
        WedFilter.currentSendMethod(e);
        return false;
      }
      return true;
    });

    $('#filter_reset_btn').on('click', () => {
      WedFilter.setDefaultValueSortDropdown();
      WedFilter.resetFilters();
      WedFilter.currentSendMethod();
      checkboxes.removeAttr('checked');
      searchInput.attr('value', '');
      return false;
    });

    $('#merchant-menu-sort-dropdown').on('change', function changeOrder() {
      const orderVal = this.value;
      $(WedFilter.filterFormId).find('[name="sort_order"]').val(orderVal);
      WedFilter.sendOrderRequest();
    });

    $('#show-filter-mob').on('click', () => {
      menuFilter.removeClass('d-none');
    });

    $('#close-filter-mob').on('click', () => {
      menuFilter.addClass('d-none');
    });
  },
  resetFilters() {
    $(WedFilter.filterFormId).find('input').val('');
    $(WedFilter.filterFormId).find('input:checkbox').prop('checked', false);
  },
  currentSendMethod(event) {
    if (WedFilter.timeout) {
      clearTimeout(WedFilter.timeout);
    }
    // According to the W3C forms specification,
    // the checked attribute is a boolean attribute,
    // which means the corresponding property is true if the attribute is present at all—even if,
    // for example, the attribute has no value or is set to empty string value or even "false".
    // This is true of all boolean attributes.
    //
    // Nevertheless, the most important concept to remember
    // about the checked attribute is that it does not correspond
    // to the checked property. The attribute actually corresponds to the defaultChecked property
    // and should be used only to set the initial value of the checkbox.
    // The checked attribute value does not change with the state of the checkbox,
    // while the checked property does.

    // The problem in our particular case is that the html code received
    // from the server does not change. Attribute check including.
    // When a block with a filter disappears and then appears again,
    // the browser will draw it as it came from the server without any current changes.
    // The code section below changes the HTML code in parallel
    // with the changes selected in the filter.

    if (event !== undefined) {
      const target = $(`#${event.currentTarget.id}`);
      if (target.attr('id') !== 'search_btn') {
        if (target.attr('checked') !== undefined) {
          target.removeAttr('checked');
        } else {
          target.attr('checked', 'checked');
        }
      } else {
        const searchInput = $('#menu-filter-search-input');
        searchInput.attr('value', searchInput.val());
      }
    }
    WedFilter.timeout = setTimeout(WedFilter.sendRequest, WedFilter.submitDelay);
  },
  sendOrderRequest() {
    $('.loading').show();
    const curRoute = $(WedFilter.filterFormId).find('[name="route"]').val();
    const newUrl = window.location.origin + WedFilter.prepareFilterData(true, curRoute);

    window.history.pushState(null, '', newUrl);
    $(WedFilter.productListId).load(
      `${newUrl} ${WedFilter.productListId} > *`,
      () => {
        $('.loading').hide();
        const productItem = $('.product-item');
        productItem.on('click', (e) => { WedFilter.showExternalSite(e); });
        productItem.on('click', '.add-product-link', (e) => { WedFilter.showProductDetail(e); });
      },
    );
  },

  sendRequest() {
    $('.loading').show();

    const curRoute = $(WedFilter.filterFormId).find('[name="route"]').val();
    const newUrl = window.location.origin + WedFilter.prepareFilterData(true, curRoute);

    window.history.pushState(null, '', newUrl);
    $(WedFilter.productListId).load(
      `${newUrl} ${WedFilter.productListId} > *`,
      (response) => {
        $('.loading').hide();
        const productsCountValue = $(response).find('.products_count_value_main').text();
        $('.products_count_value').text(productsCountValue);
        const productItem = $('.product-item');
        productItem.on('click', (e) => { WedFilter.showExternalSite(e); });
        productItem.on('click', '.add-product-link', (e) => { WedFilter.showProductDetail(e); });
      },
    );
  },
  prepareFilterData(full, route) {
    let params;
    const path = window.location.pathname;
    let form = $(this.filterFormId).serialize();

    form = `&${form}`;
    form = form.replace(/&route=[^&]+/g, '')
      .replace(/=on$/, '')
      .replace(/[&]+$/, '');

    form = `&route=${route}${form}`;

    let str = window.location.toString();
    str = str.match(/[?&]route=/);

    if (full && !str) {
      form = form.replace(/[&?]((route)|(path))[^&]+/g, '');
    }

    params = WedFilter.generateSeoUrl(form);
    params = params.replace(/&page=[0-9]+/g, '');
    params = params.replace(/(\?)|(^[&])/, '').replace(/[&]+/, '&');
    params = `?${params}`;
    return (full) ? path + params : params;
  },
  generateSeoUrl(query) {
    if (this.urlSeparators === null) {
      return query;
    }
    const params = query.split('&');
    const attrObj = {};

    if (params.length) {
      for (let i = 0; i < params.length; i += 1) {
        const parts = params[i].replace(/\+/g, ' ').split('=');
        const param = decodeURIComponent(parts[0]);
        let value = decodeURIComponent(parts[1]);
        if (typeof value === 'undefined') {
          value = '';
        }

        if (param.match(/price-[\d]+/)) {
          const attrId = param.replace(/([&]?price-)([\d]+)/, '$2');
          if (typeof attrObj.price === 'undefined') {
            attrObj.price = { values: [encodeURIComponent(attrId)] };
          } else {
            attrObj.price.values.push(encodeURIComponent(attrId));
          }
        } else if (param.match(/category-[\d]+/)) {
          const attrId = param.replace(/([&]?category-)([\d]+)/, '$2');
          if (typeof attrObj.category === 'undefined') {
            attrObj.category = { values: [encodeURIComponent(attrId)] };
          } else {
            attrObj.category.values.push(encodeURIComponent(attrId));
          }
        } else if (param.match(/search_text+/)) {
          if (value !== '') {
            if (typeof attrObj.search_text === 'undefined') {
              attrObj.search_text = { values: [encodeURIComponent(value)] };
            } else {
              attrObj.search_text.values.push(encodeURIComponent(value));
            }
          }
        } else if (param.match(/sort_order+/)) {
          if (value === '' || value === '#') {
            query = query.replace(/[&?]((sort_order))[^&]+/g, ''); // eslint-disable-line no-param-reassign
          }
        }
      }
    }

    const filterArray = [];

    Object.keys(attrObj).forEach((fname) => {
      if (Object.prototype.hasOwnProperty.call(attrObj, fname)) {
        filterArray.push(`${fname}-${this.urlSeparators.valsOpen}${attrObj[fname].values.join(this.urlSeparators.val)}${this.urlSeparators.valsClose}`);
      }
    });

    query = query.replace(/[&?]((price)|(category)|(search_text)|(search)|(filter))[^&]+/g, ''); // eslint-disable-line no-param-reassign

    if (filterArray.length) {
      query += `&search=${filterArray.join(this.urlSeparators.attr)}`; // eslint-disable-line no-param-reassign
    }

    /*  if (WedFilter.sortOrder !== '' && WedFilter.sortOrder !== '#') {
      query += `&sort_order=${WedFilter.sortOrder}`; // eslint-disable-line no-param-reassign
    } */

    return query;
  },
  showProductDetail(event) {
    event.stopPropagation();
    event.preventDefault();

    $.ajax({
      url: `/store/product?id=${event.delegateTarget.dataset.product}&size=${event.currentTarget.dataset.size}`,
      type: 'GET',
      dataType: 'json',
      success: (data) => {
        if (data.status) {
          $('#product-modal-container').html(data.html);
          const $productSize = $('#product-modal-container #product-size');
          const $productCount = $('#product-modal-container #product-count');

          // $productSize.selectize();

          $productSize.on('change', function () {
            const price = parseInt($(this).val().split('|')[0], 10);
            $productCount.html('1');
            /* eslint-disable no-bitwise */
            $('#total-product-price').html(price * ($productCount.html() | 0));
          });

          $('#minus').on('click', (ev) => {
            ev.preventDefault();
            ev.stopPropagation();
            let count = $productCount.html() | 0;
            if (count === 1) {
              return false;
            }

            // eslint-disable-next-line no-plusplus
            $productCount.html(--count);

            const price = parseInt($productSize.val().split('|')[0], 10);
            $('#total-product-price').html(price * count);
            return false;
          });

          $('#plus').on('click', (ev) => {
            ev.preventDefault();
            ev.stopPropagation();
            let count = $productCount.html() | 0;
            // eslint-disable-next-line no-plusplus
            $productCount.html(++count);
            const price = parseInt($productSize.val().split('|')[0], 10);
            $('#total-product-price').html(price * count);
          });

          $('#add-product-to-cart').on('click', () => {
            const currentProductMerchantId = $('#current-product-merchant-id').val();
            const hasItemsAnotherMerchant = ($('#has-items-another-merchant').val() === 'true');
            let confirmation = true;
            if (hasItemsAnotherMerchant) {
              // eslint-disable-next-line no-restricted-globals,no-alert
              confirmation = confirm('At the moment, you can place an order for products from only one merchant. If you add this product, the other merchant\'s products will be removed from your cart. Continue?');
            }
            if (confirmation) {
              /* eslint-disable prefer-template */
              // eslint-disable-next-line no-shadow
              const data = [
                'action=addToCart',
                'currentController=store',
                'item_id=' + $('#current-product-id').val(),
                'merchant_id=' + currentProductMerchantId,
                'category_id=' + $('#current-product-category-id').val(),
                'qty=' + $('#product-count').html(),
                'price=' + $productSize.val(),
              ];
              $.ajax({
                type: 'POST',
                dataType: 'json',
                url: '/admin/ajax',
                data: data.join('&'),
                success: (response) => {
                  if (response.code === 1) {
                    window.location.reload();
                  }
                },
              });
            } else {
              $('#orderProduct').modal('toggle');
            }
          });
          $('#orderProduct').modal();
        }
      },
    });
  },
  setDefaultValueSortDropdown() {
    const allElementList = $('#merchant-menu-sort div:last-child > div:last-child > div:first-child > div');
    const firstElementList = $('#merchant-menu-sort div:last-child > div:last-child > div:first-child > div:first-child');
    const selectOption = $('#merchant-menu-sort-dropdown option:first-child');
    const choices = $('#merchant-menu-sort > div > div.choices__inner > div > div');
    choices.attr('data-value', firstElementList.attr('data-value'));
    choices.text(firstElementList.text());
    selectOption.val(firstElementList.attr('data-value'));
    selectOption.text(firstElementList.text());
    allElementList.each((i, html) => {
      const el = $(html);
      el.removeClass('is-highlighted');
      el.attr('aria-selected', 'false');
    });
    firstElementList.addClass('is-highlighted');
    firstElementList.attr('aria-selected', 'true');
  },
  showExternalSite(event) {
    const { targetUrl } = event.currentTarget.dataset;
    const { website } = event.currentTarget.dataset;
    const { isPlaceOrder } = event.currentTarget.dataset;
    if (!isPlaceOrder) {
      let url = false;
      if (targetUrl) {
        url = targetUrl;
      } else if (website) {
        url = website;
      }
      if (url) {
        Object.assign(document.createElement('a'), { target: '_blank', href: url }).click();
      } else {
        console.log('Placing orders is prohibited, but there is no link to an external site');
      }
    }
  },
};

